import { Button } from '@driftt/tide-core-legacy'
import { CHROME_EXTENSION_LINK } from 'constants/ResourcesConstants'
import Card from 'components/playbook/components/Card'
import PlaybookDraftToggle from '../PlaybookDraftToggle'

import './style.styl'


const SignatureEnable = ({
  draft,
  isActive,
}) => (
  <div className="signature-enable-wrapper">
    <Card title="Ready to turn on your playbook?">
      <h2>Your playbook is ready.</h2>
      <div>
        <ol className="signature-enable-instructions-list">
            <li>Make sure your team has installed <a href={CHROME_EXTENSION_LINK} target="_blank" rel="nofollow noopener">Drift’s Chrome extension</a>.</li>
          <li>Once you turn this on, your email signature will be inserted into any new email created by your team in Gmail.</li>
        </ol>
      </div>
      <div className="signature-enable-toggle-container">Toggle your playbook on/off <PlaybookDraftToggle />
      </div>
    </Card>
    {isActive &&
      <div className="signature-review-report-wrapper">
        <div className="signature-review-report-information">
          <h3>Check your stats!</h3>
          <p>Don&#39;t forget to check out the Reports page for stats on:
          <ul>
            <li>Number of views</li>
            <li>Total clicks</li>
            <li>Number of conversations started from signatures</li>
            <li>Stats by teammate</li>
          </ul>
          <Button
          type="tertiary"
          href={`/reports/playbooks/${draft.id}`}>
            View Report
          </Button>
          </p>
        </div>
      </div>}
  </div>
)


export default SignatureEnable



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SignatureEnable/component.js